/* eslint-disable class-methods-use-this */
import http from '../httpService';
import { CreateSmsTemplateOffsetTenant, SmsSenderIdResult, SmsTemplate, UpdateSmsSenderId } from './smsTemplate';

class SmsTemplateService {
  public async getAll(): Promise<SmsTemplate[]> {
    const result = await http.get('api/services/app/SmsTemplate/GetAllTemplates');
    return result.data.result;
  }

  public async createSmsTemplateOffsetTenant(
    request: CreateSmsTemplateOffsetTenant
  ): Promise<void> {
    const result = await http.post(
      'api/services/app/SmsTemplate/CreateSmsTemplateOffsetTenant',
      request
    );
    return result.data.result;
  }

  public async getSmsSenderId(): Promise<SmsSenderIdResult> {
    const result = await http.get('api/services/app/SmsTemplate/GetSmsSenderId');
    return result.data.result;
  }

  public async updateSmsSenderId(request: UpdateSmsSenderId): Promise<void> {
    await http.put('api/services/app/SmsTemplate/UpdateSmsSenderId', request);
  }
}

export default new SmsTemplateService();
